export const AdminLogModuleType = {
	none: 0,
	load_doc: 1,
	unload_doc: 2,
	rank: 3,
	expo_push: 4,
	crud: 5,
	doc_parse: 6,
	tidsbanken_request: 7,
	notification: 8,
	task: 9,
	cache: 10,
	price_article: 11,
	display_request: 12,
	cmr_doc: 13,
	mail: 16,
	external_terminal: 17,
}